// The single source of truth for WHICH availability events render in the main
// feed (RBC grid + mobile agenda). The user's own marks (markEvents) always
// render; external events / sessions (allEvents) are hidden-filtered by the
// rendered SURFACE, not RBC's `view`:
//
//   - showHidden OFF              → hidden events never render.
//   - showHidden ON, month-like   → hidden events are filtered OUT of the feed
//     (they instead surface as a "# hidden" pip per day — see hiddenByDay /
//     MonthDateHeader / the mobile agenda's day-header pip).
//   - showHidden ON, week/day     → hidden events render dimmed in their slot.
//
// `monthLike` MUST be derived from the rendered surface, i.e.
// `view === "month" || (isMobile && mobileCalView === "agenda")`. Keying off
// RBC `view` alone leaked hidden rows into the mobile agenda after a
// Calendar→Agenda toggle left a stale `view` of week/day (audit A-6d).
export function selectVisibleEvents({
  allEvents = [],
  markEvents = [],
  showHidden = false,
  monthLike = false,
} = {}) {
  const base =
    !showHidden || monthLike
      ? allEvents.filter((e) => !e?.resource?.hidden)
      : allEvents;
  return [...base, ...markEvents];
}
